import { parse, serialize } from 'uri-js';

export interface GetAssetUrlOptions {
  width: number;
}

export enum SupportedUrlParams {
  Width = 'width',
}

export type UrlParamValue = string | number | undefined;
export type UrlParam = [string, string];

// TODO: Add match media list of supported attributes.
export const getAssetUrl = (stringUrl: string, { width }: GetAssetUrlOptions) => {
  if (stringUrl.length === 0) {
    return stringUrl;
  }

  const params: UrlParam[] = [[SupportedUrlParams.Width, `${width}`]];
  const parsedUrl = parse(stringUrl);

  return serialize({
    ...parsedUrl,
    query: getParamsString(getUrlParams(parsedUrl.query, params)),
  });
};

// // Assuming the string is 'param1=1&param2=2'
export const getUrlParams = (
  stringParams?: string,
  newParams?: UrlParam[],
): Map<string, UrlParamValue> => {
  const paramsMap = new Map<string, UrlParamValue>();

  if (stringParams && stringParams.length > 0) {
    stringParams.split('&').forEach((stringParam) => {
      const [key, value] = stringParam.split('=');
      paramsMap.set(key, value);
    });
  }

  if (newParams && newParams.length > 0) {
    newParams.forEach((stringParam) => {
      const [key, value] = stringParam;
      paramsMap.set(key, value);
    });
  }

  return paramsMap;
};

export const getParamsString = (map: Map<string, UrlParamValue>): string | undefined => {
  if (map.size === 0) {
    return undefined;
  }

  const paramsList: string[] = [];
  map.forEach((value, key) => {
    paramsList.push(`${key}${value ? `=${value}` : ''}`);
  });

  return paramsList.length ? paramsList.join('&') : undefined;
};
